// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"f81aec04","860":"1240467a"}[chunkId] + ".chunk.css";
};